// AUPRÉA — Étape 20 : table admin « Reformulations »
import { useEffect, useState } from "react";
import axios from "axios";
import { C, Btn, Input, Spinner, Alert } from "./shared";
import { API, hdrs, errMsg } from "./integrationShared";

const TYPES = { bilan_succession: "Bilan Succession", bilan_dirigeants: "Bilan Dirigeants" };

const Ligne = ({ r, onMsg }) => {
  const [t, setT] = useState(r.texte); const [actif, setActif] = useState(r.actif); const modif = t !== r.texte || actif !== r.actif;
  const save = async () => { try { await axios.put(`${API}/admin/reformulations/${r.id}`, { texte: t, actif }, hdrs()); r.texte = t; r.actif = actif; onMsg(`${r.numero} enregistrée ✓`); } catch (e) { onMsg(errMsg(e)); } };
  return (
    <tr data-testid={`reform-row-${r.code}`} style={{ borderTop: `.5px solid ${C.border}`, opacity: actif ? 1 : .5 }}>
      <td style={{ padding: 8, fontFamily: "monospace", whiteSpace: "nowrap" }}>{r.numero}<div style={{ fontSize: 10, color: C.muted }}>{r.code}</div></td>
      <td style={{ padding: 8, fontSize: 11, color: C.mid }}>{r.complementaire ? "Oui" : "Non / Partiellement"}</td>
      <td style={{ padding: 8, width: "70%" }}><Input value={t} onChange={e => setT(e.target.value)} data-testid={`reform-texte-${r.code}`} /></td>
      <td style={{ padding: 8 }}><label style={{ fontSize: 12, display: "flex", gap: 4 }}><input type="checkbox" checked={actif} onChange={e => setActif(e.target.checked)} />Active</label></td>
      <td style={{ padding: 8 }}><Btn small variant="gold" disabled={!modif} onClick={save} data-testid={`reform-save-${r.code}`}>Enregistrer</Btn></td>
    </tr>
  );
};

export default function ReformulationsAdmin() {
  const [d, setD] = useState(null); const [msg, setMsg] = useState("");
  useEffect(() => { axios.get(`${API}/admin/reformulations`, hdrs()).then(r => setD(r.data)); }, []);
  if (!d) return <Spinner />;
  return (
    <div data-testid="reformulations-admin">
      <div style={{ fontSize: 12.5, color: C.mid, marginBottom: 10 }}>Une phrase par question, reprise par le consultant pendant le bilan : « Vous m'avez dit que… ». Pour une réponse intermédiaire, « en partie seulement » est ajouté automatiquement.</div>
      {msg && <Alert type={msg.includes("✓") ? "info" : "error"}><span>{msg.includes("✓") ? "ℹ" : "⚠"}</span><span data-testid="reform-msg">{msg}</span></Alert>}
      {Object.entries(TYPES).map(([k, l]) => (
        <div key={k} style={{ background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, marginBottom: 16, overflowX: "auto" }}>
          <div style={{ padding: "10px 12px", fontWeight: 700, color: C.navy, fontFamily: "'Playfair Display', serif" }}>{l}</div>
          <table style={{ width: "100%", fontSize: 12.5, borderCollapse: "collapse" }}><tbody>{d.filter(r => r.type_parcours === k).map(r => <Ligne key={r.id} r={r} onMsg={setMsg} />)}</tbody></table>
        </div>
      ))}
    </div>
  );
}
